import React from 'react';
 import {useTranslation} from "react-i18next";
 import VisaTableHistory from "../../components/table/visa-history-table";
import {Link} from "react-router-dom";

const VisaHistory = () => {
  const {t} = useTranslation()
  return (
    <div className={"mb-10"}>
      <div className={"my-container rounded-lg  flex justify-between items-center w-full"}>
        <div className={"w-[207px]"}>
          <Link to={"/crew"}>
            <span className={"text-main"}>
              {t("back")}
            </span>
          </Link>
        </div>

      </div>
      <VisaTableHistory/>

    </div>
  );
};

export default VisaHistory;
